import { ApprovalFlowStepsCountDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useApprovalFlowStepsCount = (approvalFlowId?: number) => {
  const { data, loading } = useQuery(ApprovalFlowStepsCountDocument, {
    variables: { approvalFlowId: approvalFlowId ?? 0 },
    skip: !approvalFlowId,
  })

  const stepsCount = data?.approvals.approvalFlow?.stepsConnection?.totalCount ?? 0

  return {
    loading: approvalFlowId ? loading : false,
    stepsCount,
  }
}
